/**
 * Accessible code block theme for react-code-blocks.
 * Uses the react-code-blocks semantic colour object format.
 * All colours verified against white (#ffffff) background
 * to meet WCAG 2.1 AA (≥ 4.5 : 1 for normal text).
 *
 * Contrast ratios (approximate):
 *   Default / code text  #1a1a1a  ~19 : 1
 *   Comments / quotes    #5f6368  ~ 6.1 : 1
 *   Keywords / literals  #0055b3  ~ 7.1 : 1
 *   Strings / additions  #1a7f37  ~ 5.1 : 1
 *   Numbers / variables  #953800  ~ 7.4 : 1
 *   Functions / symbols  #5a2ea6  ~ 8.8 : 1
 *   Errors / deletions   #b91c1c  ~ 6.5 : 1
 */

const accessibleCodeTheme = {
  backgroundColor:           '#ffffff',
  lineNumberBgColor:         '#f5f5f5',
  lineNumberColor:           '#5f6368', // 6.1 : 1

  textColor:                 '#1a1a1a', // 19  : 1
  codeColor:                 '#1a1a1a',
  metaKeywordColor:          '#1a1a1a',
  templateTagColor:          '#1a1a1a',

  commentColor:              '#5f6368', // 6.1 : 1
  quoteColor:                '#5f6368',

  keywordColor:              '#0055b3', // 7.1 : 1
  builtInColor:              '#0055b3',
  literalColor:              '#0055b3',
  linkColor:                 '#0055b3',
  docTagColor:               '#0055b3',
  metaColor:                 '#0055b3',

  stringColor:               '#1a7f37', // 5.1 : 1
  attributeColor:            '#1a7f37',
  additionColor:             '#1a7f37',

  numberColor:               '#953800', // 7.4 : 1
  variableColor:             '#953800',
  templateVariableColor:     '#953800',
  typeColor:                 '#953800',
  selectorClassColor:        '#953800',
  builtInColor2:             '#953800',

  functionColor:             '#5a2ea6', // 8.8 : 1
  symbolColor:               '#5a2ea6',
  bulletColor:               '#5a2ea6',
  selectorIdColor:           '#5a2ea6',
  titleColor:                '#5a2ea6',

  substringColor:            '#b91c1c', // 6.5 : 1
  regexpColor:               '#b91c1c',
  deletionColor:             '#b91c1c',
  nameColor:                 '#b91c1c',
  selectorAttributeColor:    '#b91c1c',
  sectionColor:              '#b91c1c',
};

export default accessibleCodeTheme;
